<template>
  <div class="chat_room_mobile_item">
    <div class="chat_table_box">
      <div class="chat_table_ttl">휴대폰 견적 문의 드려요!</div>
      <div class="chat_table_sub">
        작성일: {{ getCreateAt(mobileRequestModel.requestedAt) || '' }}
      </div>
    </div>
    <div class="chat_table_box">
      <div class="chat_table_telecomName">
        {{ mobileRequestModel.telecomName }}
        <span>
          ({{
            mobileRequestModel.payType == 'SUPPORT' ? '공시지원' : '선택약정'
          }})
        </span>
        /
      </div>
      <div class="chat_table_modelName">
        {{ mobileRequestModel.modelName }}
        <span>({{ mobileRequestModel.deviceName }})</span>
      </div>
    </div>
    <div class="chat_table_box">
      <dl>
        <dt class="color_3">출고가</dt>
        <dd class="color_1 font_normal">
          {{ toCurrency(mobileRequestModel.factoryPrice) }}원
        </dd>
      </dl>
      <dl v-if="mobileRequestModel.payType == 'SUPPORT'">
        <dt class="color_3">공시지원금</dt>
        <dd class="color_1 font_normal">
          - {{ toCurrency(mobileRequestModel.supportMoney) }}원
        </dd>
      </dl>
      <dl>
        <dt class="color_3">매장 혜택</dt>
        <dd class="color_5 font_normal">
          - {{ toCurrency(mobileRequestModel.storeSupportMoney) }}원
        </dd>
      </dl>
      <dl>
        <dt class="color_3">할부원금</dt>
        <dd class="color_1 font_normal">
          {{ toCurrency(mobileRequestModel.principal) }}원
        </dd>
      </dl>
      <dl>
        <dt class="color_3">월 할부금</dt>
        <dd class="color_4 font_bold">
          {{ toCurrency(mobileRequestModel.monthlyInstallment) }}원
        </dd>
      </dl>
    </div>
    <div class="chat_table_box">
      <dl>
        <dt class="color_3">요금제</dt>
        <dd class="color_1 font_normal">
          {{ mobileRequestModel.joinPlanName }}
        </dd>
      </dl>
      <dl v-if="mobileRequestModel.payType == 'PLAN'">
        <dt class="color_3">선택약정할인</dt>
        <dd class="color_1 font_normal">
          - {{ toCurrency(Number(mobileRequestModel.joinPlanPrice) * 0.25) }}원
        </dd>
      </dl>
      <dl>
        <dt class="color_3">월 통신비</dt>
        <dd
          class="color_4 font_bold"
          v-if="mobileRequestModel.payType == 'SUPPORT'"
        >
          {{ toCurrency(mobileRequestModel.joinPlanPrice) }}원
        </dd>
        <dd
          class="color_4 font_bold"
          v-if="mobileRequestModel.payType == 'PLAN'"
        >
          {{
            toCurrency(
              Number(mobileRequestModel.joinPlanPrice) -
                Number(mobileRequestModel.joinPlanPrice) * 0.25,
            )
          }}원
        </dd>
      </dl>
    </div>
    <div class="chat_table_box top_line">
      <dl>
        <dt class="color_1 font_bold">월 납부 금액</dt>
        <dd
          class="font_bold color_5"
          v-if="mobileRequestModel.payType == 'SUPPORT'"
        >
          {{
            toCurrency(
              Number(mobileRequestModel.joinPlanPrice) +
                Number(mobileRequestModel.monthlyInstallment),
            )
          }}원
        </dd>
        <dd
          class="font_bold color_5"
          v-if="mobileRequestModel.payType == 'PLAN'"
        >
          {{
            toCurrency(
              Number(mobileRequestModel.joinPlanPrice) +
                Number(mobileRequestModel.monthlyInstallment) -
                Number(mobileRequestModel.joinPlanPrice) * 0.25,
            )
          }}원
        </dd>
      </dl>
    </div>
    <div
      class="chat_table_box top_line"
      v-if="mobileRequestModel.requestType != 'mobileDeal'"
    >
      <dl>
        <dt class="color_1 font_bold">안심번호</dt>
        <dd class="color_5 no_wrap" v-if="mobileRequestModel.safeNum">
          <div class="phone_wrap" v-if="safeNumView()">
            <img
              class="phone_red"
              :src="
                require('@/assets/front/images/internet_commerce/i_phone_red.svg')
              "
              alt=""
            />
            <a class="phone_href" :href="`tel:${mobileRequestModel.safeNum}`">{{
              mobileRequestModel.safeNum
            }}</a>
          </div>
          <div v-else class="phone_wrap">
            <div>만료됨</div>
          </div>
        </dd>
        <dd class="color_5 no_wrap" v-else>
          공개안함
        </dd>
      </dl>
      <dl>
        <dt class="color_1 font_bold">연락 시간대</dt>
        <dd class="color_6">
          {{ mobileRequestModel.callTime }}
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
export default {
  props: {
    mobileRequestModel: Object,
    createdAt: String,
  },
  data() {
    return {};
  },
  mounted() {},
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  methods: {
    toCurrency(val) {
      return util.toCurrency(val);
    },
    getCreateAt(createAt) {
      return format(parseISO(createAt), 'yyyy-MM-dd');
    },
    safeNumView() {
      const now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
      const create = new Date(this.createdAt);
      const create_24 = format(
        new Date(create.setDate(create.getDate() + 1)),
        'yyyy-MM-dd HH:mm:ss',
      );
      // console.log(this.createdAt);
      // console.log('this.mobileRequestModel');
      // console.log(this.mobileRequestModel);
      // console.log('now.getDate() + 1 = ' + create_24);
      // console.log('create = ' + create);
      // console.log('now.getDate() = ' + now);
      // console.log(now < create_24);
      // console.log(now < create_24);

      return now < create_24;
    },
  },
};
</script>

<style></style>
